import React, { useState, useEffect } from "react";
import UnavailabilityCalendar from "./MakeUnavaialble";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import {
  createUnavialable,
  getUnavialable,
  getUnavialableAppointment,
} from "../../redux/action/Appointment";
import UnavailableCalender from "./UnavailableCalender";
import IMAGES from "../../constants/images";
import Model from "../Model";
import { resetUnavailable } from "../../redux/slice/Appointment";
import ConfirmationModel from "../ConfirmationModel";
import UnavailableConfirm from "../UnavailableConfirm";
import { getAppointment } from "../../redux/action/Appointment";

export default function Unavialable() {
  const dispatch = useDispatch();

  const { data, loading, error } = useSelector(
    (state) => state.CREATE_UNAVIALABLE
  );
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [icon, setIcon] = useState(null);
  const [show, setShow] = useState(false);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [reason, setReason] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [time, setTime] = useState(null);
  const [isAvaiable, setIsAvaiable] = useState(false);
  const formatDate = (date) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${monthNames[date.getMonth()]} ${date.getDate()}`;
  };

  const saveUnavialable = () => {
    let message =
      moment(start).format("DD MMM YYYY") +
      " to " +
      moment(end).format("DD MMM YYYY");
    setTime(message);
    setShowConfirm(true);
    dispatch(getUnavialable());
    dispatch(getUnavialableAppointment());
    // console.log("date", moment(start).format("YYYY-MM-DD"));
  };

  useEffect(() => {
    console.log("datata", data, error);
    if (data) {
      if (data === "Schedule created") {
        setShow(true);

        setTitle("Unvailability Created");
        setDescription("Your availability created successfully.");
        setIcon(IMAGES.profile_success);
      }
    }
    if (error) {
      setShow(true);

      setTitle("Unvailability Creation Failed");
      setDescription(error.payload);
      setIcon(IMAGES.slot_error);
    }
  }, [data, error]);

  const createUnavailable = () => {
    if (start !== null && end !== null) {
      let payload = {
        unAvailableRequest: [
          {
            unaAvailableStartDate: moment(start).format("YYYY-MM-DD"),
            unaAvailableEndDate: moment(end).format("YYYY-MM-DD"),
            reason: reason,
          },
        ],
      };
      dispatch(createUnavialable(payload)).then(() => {
        dispatch(getUnavialableAppointment());
        dispatch(getUnavialable());
      });
    }
  };

  const getUpcoming = () => {};

  useEffect(() => {
    getUpcoming();
  }, []);

  return (
    <>
      <div className="w-full max-w-[1200px] flex flex-col flex-1 min-h-0">
        <div className="flex flex-col md:flex-row flex-1 min-h-0 gap-4">
          <div className="flex-1 px-3 text-white flex flex-col min-h-0">
            <div className=" p-0">
              <UnavailabilityCalendar
                setStart={setStart}
                setEnd={setEnd}
                setReason={setReason}
                setIsAvaiable={setIsAvaiable}
              />
            </div>
          </div>
          <div className="flex-1 px-3 flex flex-col min-h-0">
            <UnavailableCalender />
          </div>
        </div>
        <div className="flex justify-end gap-3 mr-3 items-end h-[60px]">
          <button
            className="h-10 px-5 py-0 text-sm font-semibold rounded-xl font-poppins text-[#334155] bg-white shadow-sm hover:bg-[#F8FAFC] transition-colors"
            style={{ border: "1px solid #E2E8F0" }}
          >
            Cancel
          </button>
          <button
            className="h-10 px-5 py-0 text-sm font-semibold rounded-xl font-poppins text-white btn-gradient shadow-sm"
            onClick={() => saveUnavialable()}
          >
            Apply
          </button>
        </div>
      </div>

      {show && (
        <Model
          show={show}
          setShow={(v) => {
            setShow(v);
            dispatch(resetUnavailable());
          }}
          title={title}
          description={description}
          icon={icon}
        />
      )}
      {
        <UnavailableConfirm
          isOpen={showConfirm}
          onClose={setShowConfirm}
          time={time}
          isAvaiable={isAvaiable}
          create={() => {
            createUnavailable();
            setShowConfirm(false);
          }}
          cancel={setShowConfirm}
        />
      }
    </>
  );
}
